// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header[data-v-2160a90e]{margin-bottom:10px}.title[data-v-2160a90e]{font-size:20px;letter-spacing:normal}", ""]);
// Exports
module.exports = exports;
